import { render } from "./TrabajadorCreate.vue?vue&type=template&id=410a40d4&scoped=true"
import script from "./TrabajadorCreate.vue?vue&type=script&lang=js"
export * from "./TrabajadorCreate.vue?vue&type=script&lang=js"

import "./TrabajadorCreate.vue?vue&type=style&index=0&id=410a40d4&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410a40d4"]])

export default __exports__